import { render } from "./TheForm.vue?vue&type=template&id=e5790c3e"
import script from "./TheForm.vue?vue&type=script&lang=js"
export * from "./TheForm.vue?vue&type=script&lang=js"

import "./TheForm.vue?vue&type=style&index=0&id=e5790c3e&lang=css"

import exportComponent from "C:\\www\\webdesign - zelena\\vue\\dotacezelena-cz\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__